module.exports = __webpack_public_path__ + "static/light-bulb-e88afff220a824c124002fce284ca99d.png";